module.exports = __webpack_public_path__ + "static/media/(H)-Prata-06.d496decd.jpg";